import React, { useCallback } from 'react';

import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import gStyles from 'config/styles';

import { selectLayoutConfig } from 'store/config/selectors';

import useHeaderConfig from 'utils/hooks/useHeaderConfig';
import { isWeb } from 'utils/responsiveness';

import SettingsRowItem from '../components/RowItem';
import WebHeader from '../components/WebHeader';
import useBackendInfoLineups from '../hooks/useBackendInfoLineups';
import { BackendInfoLineup } from '../types';
import styles from './styles';

const BackendInfoPage = () => {
    const { t } = useTranslation();

    const { background } = useSelector(selectLayoutConfig);
    const { backendInfoLineups } = useBackendInfoLineups();
    useHeaderConfig({ isRoot: isWeb, disableFocusOnMount: true });

    const renderItem = useCallback(
        ({ item, index }: ListRenderItemInfo<BackendInfoLineup>) => {
            return (
                <SettingsRowItem
                    item={item}
                    title={t(item.title)}
                    rightTitle={item.rightTxt}
                    style={styles.container}
                    titleContainerStyle={styles.titleContainer}
                    rightTitleStyle={styles.subtitle}
                    disabled
                    position={index + 1}
                    total={backendInfoLineups.length}
                />
            );
        },
        [],
    );

    return (
        <View
            style={[gStyles.settingsContainer, { backgroundColor: background }]}
        >
            {isWeb && (
                <WebHeader
                    title={t('SETTINGS_BACKEND_INFORMATION')}
                    disableFocusOnMount
                />
            )}
            <FlatList
                style={[
                    gStyles.settingsContentContainer,
                    { backgroundColor: background },
                ]}
                data={backendInfoLineups}
                keyExtractor={keyExtractor}
                renderItem={renderItem}
                accessibilityRole="menu"
            />
        </View>
    );
};

export default BackendInfoPage;

function keyExtractor(item: { id: string }) {
    return item.id;
}
